import { Inject, Injectable } from '@angular/core';
import { WebsocketProvider } from '../interfaces/websocket-provider.interface';
import { Observable } from 'rxjs';
import { ConnectionData, WEBSOCKET_IMPLEMENTATION_CLASS } from '../providers/web-socket-connection.provider';
import { WEBSOCKET_CONNECTION_DATA } from '../providers/web-socket-connection.provider';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService implements WebsocketProvider {
  public config!: ConnectionData;

  constructor(
    @Inject(WEBSOCKET_IMPLEMENTATION_CLASS)
    private websocketImplementation: WebsocketProvider,
    @Inject(WEBSOCKET_CONNECTION_DATA)
    private connectionInfo: ConnectionData,
    ) {
    this.setConfig(this.connectionInfo);
    this.websocketImplementation.initialize();
  }

  /**
   * Set the configuration for the websocket connection
   *
   * @param connectionData
   */
  public setConfig(connectionData: ConnectionData): void {
    this.websocketImplementation.setConfig(connectionData);
  }

  /**
   * Disconnect the current client connection
   */
  public disconnect(): void {
    this.websocketImplementation.disconnect();
  }

  /**
   * Listen for specific events on a specific channel
   * @param channel - name of the channel
   * @param event - name of the event
   * @param privateChannel - define whether it's a private channel or not
   */
  public listenForEvent<T = any>(channel: string, event: string, privateChannel: boolean = false): Observable<T> {
    return this.websocketImplementation.listenForEvent(channel, event, privateChannel);
  }

  /**
   * Listen all events on a specific channel
   * @param channel - name of the channel
   * @param privateChannel - define whether it's a private channel or not
   */
  public listenGlobal<T = any>(channel: string, privateChannel: boolean = false): Observable<T> {
    return this.websocketImplementation.listenGlobal(channel, privateChannel);
  }

  /**
   * Initialize the websocket connection
   */
  public initialize(): void {
    this.websocketImplementation.initialize()
  }
}
